// extracted by mini-css-extract-plugin
export var container = "Recruit-module--container--4qB4Q";
export var bgRecruit = "Recruit-module--bgRecruit--MWpae";
export var inner = "Recruit-module--inner--pMpr5";
export var recruitLink = "Recruit-module--recruitLink--KTlZS";